import { useState } from 'react';
import { Box, VStack, HStack, Text, useMediaQuery } from 'native-base';
import { MOBILE_VIEW_WIDTH } from '../../../../utils/screens';
import CustomModal from '../../../../components/modal';
import MobileModelSheet from '../../../../components/actionSheet';
import CustomButton from '../../../../components/button';
import FileUploader from '../../../../containers/fileUpload';
import config from '../../../../utils/config';
import { Toaster } from '../../../../components/toaster';
import { LoaderAnimation } from '../../../../components/spinner';
import { bulkUploadHotelDetailsAPI } from '../../../../api/apis/quicklinks';

const BulkUploadModal = ({ isOpen, onClose, onSuccess }) => {
  const [MobileWindow] = useMediaQuery({ maxWidth: MOBILE_VIEW_WIDTH });
  const toaster = Toaster();
  const [selectedFile, setSelectedFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);

  const handleFileSelect = (files) => {
    if (files && files.length > 0) {
      // Validate file type
      const file = files[0];
      const fileExtension = file.name.split('.').pop().toLowerCase();
      if (!['xls', 'xlsx'].includes(fileExtension)) {
        toaster('Please select an Excel file (.xls or .xlsx)', 'error', 'error');
        return;
      }

      // Validate file size (10MB limit)
      const maxSize = 10 * 1024 * 1024; // 10MB in bytes
      if (file.size > maxSize) {
        toaster('File size should be less than 10MB', 'error', 'error');
        return;
      }

      setSelectedFile(file);
    }
  };

  const handleUpload = async () => {
    if (!selectedFile) {
      toaster('Please select a file to upload', 'error', 'error');
      return;
    }

    setIsUploading(true);
    try {
      LoaderAnimation.show();
      const response = await bulkUploadHotelDetailsAPI(selectedFile);

      if (response.error) {
        toaster(
          response.message || 'Failed to upload hotel details',
          'error',
          'error'
        );
      } else {
        const responseData = response?.data;
        const message = responseData?.message || 'Hotel details uploaded successfully';
        toaster(message, 'success', 'success');
        onSuccess();
        handleClose();
      }
    } catch (error) {
      console.error('Error uploading hotel details:', error);
      toaster('Error uploading hotel details', 'error', 'error');
    } finally {
      setIsUploading(false);
      LoaderAnimation.hide();
    }
  };

  const handleClose = () => {
    setSelectedFile(null);
    setIsUploading(false);
    onClose();
  };

  const modalBody = () => (
    <VStack space={4}>
      <FileUploader
        files={selectedFile ? [selectedFile] : []}
        setFiles={handleFileSelect}
        templates={true}
        href={config.hotelTemplateUrl}
        accept={['xls', 'xlsx']}
        types='.xls, .xlsx'
        multiple={false}
      />
    </VStack>
  );

  const modalFooter = () => (
    <HStack
      justifyContent='end'
      width='100%'
    >
      <CustomButton
        text='Upload'
        onPress={handleUpload}
        isLoading={isUploading}
        disabled={!selectedFile}
      />
    </HStack>
  );

  return (
    <>
      {!MobileWindow ? (
        <CustomModal
          isOpen={isOpen}
          onClose={handleClose}
          header='Bulk Upload Hotel Details'
          body={modalBody()}
          footer={modalFooter()}
          width='60%'
        />
      ) : (
        <MobileModelSheet
          isOpen={isOpen}
          onClose={handleClose}
          header='Bulk Upload Hotel Details'
          body={modalBody()}
          footer={modalFooter()}
          maxH='80vh'
        />
      )}
    </>
  );
};

export default BulkUploadModal; 